import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";

var DefiHeaderLogo =
/*#__PURE__*/
function (_Component) {
  _inherits(DefiHeaderLogo, _Component);

  function DefiHeaderLogo() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DefiHeaderLogo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DefiHeaderLogo)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderImage = function () {
      var _this$props = _this.props,
          logo = _this$props.logo,
          className = _this$props.className;
      var src = localStorage.logo ? localStorage.logo : "/Home/GetLogo";
      return React.createElement("img", {
        src: src,
        alt: "logo",
        className: className
      });
    };

    return _this;
  }

  _createClass(DefiHeaderLogo, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          logo = _this$props2.logo,
          logoLink = _this$props2.logoLink;
      var href = logoLink ? logoLink : logo === 'client' ? '/Home/Landing' : null;

      if (href) {
        return React.createElement("a", {
          id: "logoLink",
          href: href
        }, React.createElement(Grid, {
          container: true,
          alignItems: "center"
        }, this.renderImage()));
      }

      return this.renderImage();
    }
  }]);

  return DefiHeaderLogo;
}(Component);

export default DefiHeaderLogo;